require('./bootstrap');
require('animate.css');

$(document).ready(function () {

    //Klikken op een item met een submenu, is eerst uitschuiven submenu, daarna na 2de klik pas link volgen
    // $(".nav-link").click(function(klik){
    //     if($(window).width()<1200){
    //         if($(this).siblings(".small-menu").length>0){
    //             var submenu=$(this).siblings(".small-menu");
    //             //Kijken of deze sub al is uitgeklapt?
    //             if((!(submenu.hasClass("d-block")))){
    //                 klik.stopImmediatePropagation()
    //                 klik.preventDefault();
    //                 submenu.addClass("d-block");
    //             }
    //         }
    //     }
    // });

    $('.collapsebtn').on('click', function() {
        $(this).nextAll(".dropdown-menu").toggleClass('show');
        if($(this).nextAll(".dropdown-menu").hasClass('show')){
            $(this).text("-");
            $(this).show();
        } else {
            $(this).text("+");
            $(this).hide();
        }
    });

    //////////////////////////
    //      SCROLL MENU     //
    //////////////////////////
    var position = $(window).scrollTop();

    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if(position > 200) {
                if(!$( "#menu" ).hasClass( "scrollMenu" )) {
                    $('#menu').hide();
                    $('#menu').addClass('scrollMenu');
                    $('#menu').delay(0).slideDown(250);
                }
        } else {
            $('#menu').removeClass('scrollMenu', {duration:1000});
            $('body').removeClass('scrollMenu-margin');
        }
        position = scroll;
    });


    // Make dropdown parent clickable and hover effect
    $('.navbar .dropdown').hover(function () {
        $(this).find('.dropdown-menu').first().stop(true, true).delay(0).slideDown();

    }, function () {
        $(this).find('.dropdown-menu').first().stop(true, true).delay(0).slideUp();

    });

    $('.navbar .dropdown > a').click(function () {
        location.href = this.href;
    });

    // Dropdown menu image change
    $('.dropdown-item').on('mouseenter', function(){
        var hoveredItem = $(this).data('dropdown-link');

        $('.dropdownimage img').each(function () {
            if(!$(this).hasClass('d-none')) {
                $(this).addClass('d-none');
            }
        });

        $("img[data-dropdown-image='" + hoveredItem +"']").removeClass('d-none');
    });

    // Check if element is scrolled into view
    function isScrolledIntoView(elem) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();

        var elemTop = $(elem).offset().top;
        var elemBottom = elemTop + $(elem).height();

        return (docViewBottom >= elemTop);
        // return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }

    // If element is scrolled into view, fade it in with Animate.css
    $(window).scroll(function () {
        $('.fadetop').each(function () {
            if (isScrolledIntoView(this) === true) {
                $(this).addClass('animate__animated animate__fadeInUp animate__delay-1s');
            }
        });
    });

    // webshop detail - set height of product slider based on content height
    var calcContentHeight = $( '.calc-content-height' ).height();
    $('.product-slider #productCarousel .carousel-inner').css('height', calcContentHeight+'px');

    // Webshop winkelmand uppdate amount
    $('.winkelmand-quantity').on('focusout', function() {
        $(this).parent().submit();
    });

    $('.product-winkelmand-list .quantiy-down-winkelmand').on('click', function() {
        var number = Number($(this).parent().find( "input[type=number]" ).val());
        var newAmount = Number(number) - 1;
        $(this).parent().find( "input[type=number]" ).val(newAmount);
        $(this).parent().parent().submit();
    })
    $('.product-winkelmand-list .quantiy-up-winkelmand').on('click', function() {
        var number = Number($(this).parent().find( "input[type=number]" ).val());
        var newAmount = Number(number) + 1;
        $(this).parent().find( "input[type=number]" ).val(newAmount);
        $(this).parent().parent().submit();
    })

    $('.add-to-cart-form').on('submit', function(e) {
        e.preventDefault();

        $form = $(this);

        $.ajax({
            url: $form.attr('action'),
            method: $form.attr('method'),
            data: $form.serialize(),
            success: function(result) {

                if (typeof result.url !== 'undefined') {
                    window.location = result.url;
                    return;
                }

                $(result.view).modal('show');
            }
        });
    });

    // Add up product quantity
    $('.quantiy-down').on('click', function() {
        var number = Number($(this).parent().find( "input[type=number]" ).val());
        var newAmount = Number(number) - 1;
        $(this).parent().find( "input[type=number]" ).val(newAmount)
    })
    $('.quantiy-up').on('click', function() {
        var number = Number($(this).parent().find( "input[type=number]" ).val());
        var newAmount = Number(number) + 1;
        $(this).parent().find( "input[type=number]" ).val(newAmount)
    })

    // Search function
    $('.search-function').on('click', function() {
        $('.search-bar').slideToggle(200);
    });

    // Afrekenen formulier

    $('#account-aanmaken').on('click', function(){
        $('.wachtwoord-container').toggle();
    });

    $('#ander-adres').on('click', function(){
        $('.factuur-adres').toggle();
    });

    if ($('#account-aanmaken').is(':checked')) {
        $('.wachtwoord-container').show();
    }

    if ($('#ander-adres').is(':checked')) {
        $('.factuur-adres').show();
    }

    function createCookie(name,value,days) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime()+(days*24*60*60*1000));
            var expires = "; expires="+date.toGMTString();
        }
            else { var expires = "";
        }

        document.cookie = name+"="+value+expires+"; path=/";
    }

    // Leeftijdscheck
    $('#leeftijdscheck-container .allow').on('click', function() {
        createCookie('age_check', 1, 30);
        $('#leeftijdscheck-container').hide();
    })

    $('#leeftijdscheck-container .disallow').on('click', function() {
        $('.leeftijdscheck-not-allowed').show();
    })

});

/*!
 * jQuery serializeObject - v0.2 - 1/20/2010
 * http://benalman.com/projects/jquery-misc-plugins/
 *
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */

// Whereas .serializeArray() serializes a form into an array, .serializeObject()
// serializes a form into an (arguably more useful) object.

$.fn.serializeObject = function(){
    var obj = {};

    $.each( this.serializeArray(), function(i,o){
        var n = o.name,
            v = o.value;

        obj[n] = obj[n] === undefined ? v
            : $.isArray( obj[n] ) ? obj[n].concat( v )
                : [ obj[n], v ];
    });

    return obj;
};
